import { checkAuth } from '@/utils/permission'

/**
 * v-auth-disable 指令：与 v-auth（无权限删除元素）不同，无权限时**保留元素并置灰 + 悬停说明**，
 * 拦截点击但不触发动作。专为 el-button 等需要保留占位、提示「无操作权限」的场景设计。
 *
 * 安全要点（避免回归）：
 * - 不操作元素的原生 `disabled` 属性，避免与 el-button 自身的 `:disabled`（如「未选中时禁用」）冲突；
 * - 不使用 pointer-events:none（那会同时屏蔽 hover，导致 title 提示无法显示），改用捕获阶段
 *   监听拦截 click（stopImmediatePropagation + preventDefault），既阻断动作又保留 hover 提示；
 * - 幂等：用 el._authDisabled 标记，inserted/update 多次触发不重复加监听。
 */
const TITLE = '无操作权限'

function block(e) {
  e.stopPropagation()
  e.stopImmediatePropagation()
  e.preventDefault()
}

function apply(el, binding) {
  const allowed = checkAuth(binding.value, binding.arg)
  if (allowed) {
    if (el._authDisabled) {
      el.classList.remove('is-auth-disabled')
      el.style.opacity = ''
      el.style.cursor = ''
      if (el.getAttribute('title') === TITLE) el.removeAttribute('title')
      el.removeEventListener('click', block, true)
      el._authDisabled = false
    }
  } else if (!el._authDisabled) {
    el.classList.add('is-auth-disabled')
    el.style.opacity = '0.5'
    el.style.cursor = 'not-allowed'
    el.setAttribute('title', TITLE)
    el.addEventListener('click', block, true)
    el._authDisabled = true
  }
}

export default {
  inserted: apply,
  update: apply
}
